/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Color_LabelInputs */

const en_ui_studio_color_label = /** @type {(inputs: Ui_Studio_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track color`)
};

const de_ui_studio_color_label = /** @type {(inputs: Ui_Studio_Color_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farbe des Tracks`)
};

/**
* | output |
* | --- |
* | "Track color" |
*
* @param {Ui_Studio_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_color_label = /** @type {((inputs?: Ui_Studio_Color_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Color_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_color_label(inputs)
	return de_ui_studio_color_label(inputs)
});